import React from 'react'

import cx from 'classnames'
import propTypes from 'prop-types'

const Container = ({
  id, children, className, fluid,
}) => {
  const baseClass = fluid ? 'container-fluid' : 'container'

  return (
    <div className={cx(baseClass, className)} id={id}>
      {children}
    </div>
  )
}

Container.propTypes = {
  id: propTypes.string,
  children: propTypes.node,
  fluid: propTypes.bool,
  className: propTypes.string,
}

export default Container
